import React from 'react';
import { Box, ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import TestimonialSection from './components/TestimonialSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ minHeight: '100vh', overflow: 'hidden' }}>
        <Header />
        <HeroSection />
        <ProblemSection />
        <SolutionSection />
        <TestimonialSection />
        <FaqSection />
        <Footer />
      </Box>
    </ThemeProvider>
  );
};

export default App;
